/*!
 * functions.js
 * (c) 2024 Klonbits, Inc.
 * All rights reserved.
 */

function fakeInputsInit() {
	$('.fake-inputs').each(function () {
		var $this = $(this);
		var $fakeinput = $this.find('input');
		var $fakeinputNotReadonly = $this.find('input:not([readonly])');
		var hasValueClass = 'has-value';

		$fakeinput.val() != '' ? $this.addClass(hasValueClass) : '';

		$fakeinputNotReadonly.on({
			focus: function () {
				$this.addClass(hasValueClass);
			},
			blur: function () {
				$(this).val() == '' ? $this.removeClass(hasValueClass) : '';
			},
		});
	});
}

function addEvent(evnt, elem, func) {
	if (elem.addEventListener)
		// W3C DOM
		elem.addEventListener(evnt, func, false);
	else if (elem.attachEvent) {
		// IE DOM
		elem.attachEvent('on' + evnt, func);
	} else {
		// No much to do
		elem['on' + evnt] = func;
	}
}

function setHeaderHeight() {
	var headerHeight = document.querySelector('.header-nav').offsetHeight;

	document.documentElement.style.setProperty('--hh', headerHeight + 'px');
}

function animatedHeaderInit() {
	var docElem = document.documentElement,
		header = document.querySelector('.header'),
		headerNav = document.querySelector('.header-nav'),
		searchWrapper = document.querySelector('.search-wrapper'),
		subMenuSection = document.querySelector('.submenu-section'),
		didScroll = false,
		changeHeaderOn = 300,
		changeSubOn = document.querySelector('.submenu-section') != null ? document.querySelector('.submenu-section').offsetTop + document.querySelector('.submenu-section').offsetHeight : 0;

	function scrollPage() {
		var sy = scrollY();

		// if (!$(headerNav).hasClass('is-shown') && !$(searchWrapper).hasClass('is-shown')) {
		if (sy >= changeHeaderOn) {
			header.classList.add('ani--header');
		} else {
			header.classList.remove('ani--header');
		}

		if (subMenuSection != null) {
			if (sy >= changeSubOn && sy < changeSubOn + 400) {
				subMenuSection.classList.add('t');
			} else if (sy >= changeSubOn + 400) {
				subMenuSection.classList.add('is-fixed');
			} else {
				subMenuSection.classList.remove('is-fixed');
				subMenuSection.classList.remove('t');
			}
		}

		// }

		didScroll = false;
	}

	function scrollY() {
		return window.pageYOffset || docElem.scrollTop;
	}

	function addEvent(evnt, elem, func) {
		if (elem.addEventListener)
			// W3C DOM
			elem.addEventListener(evnt, func, false);
		else if (elem.attachEvent) {
			// IE DOM
			elem.attachEvent('on' + evnt, func);
		} else {
			// No much to do
			elem['on' + evnt] = func;
		}
	}

	setTimeout(scrollPage, 250);

	window.addEventListener('scroll', function (event) {
		if (!didScroll) {
			didScroll = true;
			setTimeout(scrollPage, 250);
		}
	});
}

function setVH() {
	// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
	var vh = window.innerHeight * 0.01;
	// Then we set the value in the --vh custom property to the root of the document
	document.documentElement.style.setProperty('--vh', vh + 'px');
}

function setHeroSlideAR(ww) {
	if (ww >= 768 && ww < 1200) {
		var pb = getAR(690, 768);

		document.documentElement.style.setProperty('--hsAR', pb + 'px');
	} else if (ww >= 1200) {
		var pb = getAR(700, 1440);

		document.documentElement.style.setProperty('--hsAR', pb + 'px');
	}
}

function getAR(h, w) {
	var mode = null;
	var dividend = null;
	var divisor = null;
	var remainder = null;
	var aspectRatio = null;

	if (h > w) {
		dividend = h;
		divisor = w;
		mode = 'portrait';
	}

	if (w > h) {
		dividend = w;
		divisor = h;
		mode = 'landscape';
	}

	var gcd = -1;
	while (gcd == -1) {
		remainder = dividend % divisor;
		if (remainder == 0) {
			gcd = divisor;
		} else {
			dividend = divisor;
			divisor = remainder;
		}
	}

	var hr = w / gcd;
	var vr = h / gcd;
	aspectRatio = hr / vr;
	return aspectRatio;
}

function initFWMap(mapID) {
	var ww = $(window).outerWidth();
	var mapElem = document.getElementById(mapID);
	var zoom = 0;

	if (ww > 767.99) {
		zoom = 7.6;
	} else if (ww > 1279.99) {
		zoom = 7;
	} else {
		zoom = 6.4;
	}

	var map = new google.maps.Map(mapElem, {
		zoom: zoom,
		center: { lat: 36.7953284, lng: 29.409261 },
		disableDefaultUI: true,
	});

	var voyageHotels = ['Voyage Hotel Bodrum', 'Voyage Hotel Torba', 'Voyage Bodrum Türkbükü', 'Voyage Belek Golf & Spa', 'Voyage Sorgun'];

	var locations = [
		{ lat: 37.0345439, lng: 27.3972088 },
		{ lat: 37.0628451, lng: 27.4279808 },
		{ lat: 37.1404634, lng: 27.307888 },
		{ lat: 36.8469397, lng: 31.0722299 },
		{ lat: 36.7569427, lng: 31.4190772 },
	];

	var markers = locations.map(function (location, i) {
		return new google.maps.Marker({
			position: location,
			label: voyageHotels[i],
			animation: google.maps.Animation.DROP,
		});
	});

	var clusterStyles = [
		{
			textColor: 'black',
			url: '/assets/svg/map/ico-dot-blue.svg',
			height: 55,
			width: 55,
		},
		{
			textColor: 'black',
			url: '/assets/svg/map/ico-dot-green.svg',
			height: 55,
			width: 55,
		},
	];

	var mcOptions = {
		gridSize: 50,
		styles: clusterStyles,
		maxZoom: 10,
		zoomOnClick: false,
		minimumClusterSize: 2,
	};

	var markerCluster = new MarkerClusterer(map, markers, mcOptions);

	markerCluster.setCalculator(function (markers, numStyles) {
		var index = 0;
		var count = markers.length;
		var dv = count;
		while (dv !== 0) {
			dv = parseInt(dv / 3, 3);
			index++;
		}

		index = Math.min(index, numStyles);
		return {
			text: count,
			index: index,
		};
	});

	markerCluster.addListener('click', function (e) {
		map.setCenter(e.getCenter());
		map.setZoom(map.getZoom() + 3);
	});
}

function initMap(mapElementId = 'googlemap') {
	/* Get `mapConfig` from `window.defineConfig__${mapElementId}`  */
	const mapConfig = window[`defineConfig__${mapElementId}`] || { center: { lat: 36.7953284, lng: 29.409261 }, markerLocations: [] };
	/* Create Map */
	const ww = $(window).outerWidth();
	var zoom = 0; if (ww > 1279.99) { zoom = 9; } else if (ww > 767.99) { zoom = 7.4; } else { zoom = 6.5; }
	const mapOptions = { mapId: mapConfig.mapId, center: mapConfig.center, zoom: zoom, disableDefaultUI: true, }
	const mapElement = document.getElementById(mapElementId);
	const map = new google.maps.Map(mapElement, mapOptions);
	/* Set Marker Locations */
	const markerLocations = mapConfig.markerLocations;
	/* Create an info window to share between markers. */
	const infoWindow = new google.maps.InfoWindow();
	/* Set Markers */
	for (let marker of markerLocations) { if (marker) { /* console.debug(`markerLocations:::marker`, marker); */ /* Marker */ addAdvancedMarkerView(map, marker); } }
	/* Add AdvancedMarkerView & InfoWindow */
	function addAdvancedMarkerView(mapInstance, marker) {
		const infoWindowContent = document.createElement("div"); infoWindowContent.className = "g__InfoWindow"; infoWindowContent.innerHTML = `<h3>${marker.label}</h3><p>${marker.info}</p>`;
		/* Create the markers. */
		const markerViewContent = document.createElement("div"); markerViewContent.className = "g__AdvencedMarkerView"; markerViewContent.textContent = marker.label;
		const markerView = new google.maps.marker.AdvancedMarkerView({ map: mapInstance, position: new google.maps.LatLng(marker.position.lat, marker.position.lng), title: `${marker.label}`, content: markerViewContent });
		/* Add a click listener for each marker, and set up the info window. */
		markerView.addListener('click', ({ domEvent, latLng }) => { const { target } = domEvent; infoWindow.close(); infoWindow.setContent(infoWindowContent); infoWindow.open(markerView.map, markerView); })
	}
}

window.initMap = initMap;

var arrayOfSliders = [];

function onePerViewSlidersInit() {
	$('[slidesOnePerViewSlide]').each(function () {
		var config = {
			slidesPerView: 1,
			spaceBetween: 15,
			loop: true,
			watchSlidesVisibility: true,
			containerModifierClass: 'slider-container--',
			wrapperClass: 'slider-wrapper',
			slideClass: 'slider-slide',
			slideActiveClass: 'slider-slide--active',
			slideNextClass: 'slider-slide--next',
			slidePrevClass: 'slider-slide--prev',
			pagination: {
				el: this.querySelector('[class*=slider-pagination]'),
				bulletClass: 'slider-pagination-bullet--dark',
				bulletActiveClass: 'slider-pagination-bullet--active',
				currentClass: 'slider-pagination-bullet--current',
				hiddenClass: 'slider-pagination-bullet--hidden',
				clickable: true,
			},
			navigation: {
				prevEl: $(this).find('.slider-icons--prev'),
				nextEl: $(this).find('.slider-icons--next'),
			},
			lazy: {
				elementClass: 'lazy',
				loadPrevNext: true,
				loadedClass: 'lazy-loaded',
			},
		};

		arrayOfSliders.push(new Swiper($(this).find('.slider-container')[0], config));
	});
}

function heroSliderV2Init() {
	$('.hero-slider--v2').each(function () {
		var slider = $(this);
		var config = {
			slidesPerView: 1,
			centeredSlides: true,
			loop: true,
			containerModifierClass: 'hero-slider--v2-',
			wrapperClass: 'hero-wrapper',
			slideClass: 'hero-slide',
			slideActiveClass: 'hero-slide--active',
			slideNextClass: 'hero-slide--next',
			slidePrevClass: 'hero-slide--prev',
			pagination: {
				el: '.hero-slider--v2 .slider-pagination',
				bulletClass: 'slider-pagination-bullet--dark',
				bulletActiveClass: 'slider-pagination-bullet--active',
				currentClass: 'slider-pagination-bullet--current',
				hiddenClass: 'slider-pagination-bullet--hidden',
				clickable: true,
			},
			navigation: {
				prevEl: '.slider-icons.slider-icons--prev',
				nextEl: '.slider-icons.slider-icons--next',
			},
			lazy: {
				elementClass: 'lazy',
				loadPrevNext: true,
				loadedClass: 'lazy-loaded',
			},
		};

		arrayOfSliders.push(new Swiper(slider, config));
	});
}

function freeModeSliderInit() {
	$('.slider--free-mode').each(function () {
		var slider = $(this).find('.slider-container');
		var config = {
			slidesPerView: 1.25,
			spaceBetween: 15,
			centeredSlides: true,
			loop: true,
			watchSlidesVisibility: true,
			containerModifierClass: 'slider-container--',
			wrapperClass: 'slider-wrapper',
			slideClass: 'slider-slide',
			slideActiveClass: 'slider-slide--active',
			slideNextClass: 'slider-slide--next',
			slidePrevClass: 'slider-slide--prev',
			pagination: {
				el: '.slider--free-mode .slider-pagination--relative',
				bulletClass: 'slider-pagination-bullet--dark',
				bulletActiveClass: 'slider-pagination-bullet--active',
				currentClass: 'slider-pagination-bullet--current',
				hiddenClass: 'slider-pagination-bullet--hidden',
				clickable: true,
			},
			navigation: {
				prevEl: '.slider-icons.slider-icons--prev',
				nextEl: '.slider-icons.slider-icons--next',
			},
			lazy: {
				elementClass: 'lazy',
				loadPrevNext: true,
				loadedClass: 'lazy-loaded',
			},
			breakpoints: {
				768: {
					slidesPerView: 3.75,
					spaceBetween: 10,
				},
				1280: {
					slidesPerView: 4.2981,
					spaceBetween: 30,
				},
			},
		};

		arrayOfSliders.push(new Swiper(slider, config));
	});
}

function roomsSliderInit() {
	$('.rooms-slider').each(function () {
		var slider = $(this).find('.slider-container');
		var sliderSlides = slider.find('.slider-slide');
		var slidesPerView_md = 2;
		var slidesPerView_lg = 2;
		var slidesPerView_sm = 2;

		if (sliderSlides.length > 2) {
			slidesPerView_sm = 3;
			slidesPerView_md = 3;
			slidesPerView_lg = 2.1628;
		}
		else if(sliderSlides.length ==1)
		{
			var slidesPerView_md = 1;
			var slidesPerView_lg = 1;
			var slidesPerView_sm = 1;

			var roomSliderSection = document.querySelector('.rooms-slider');
			if(screen.width<415)
			{
			roomSliderSection.style.maxWidth="50%";
			roomSliderSection.style.margin="auto";
			}
			else
			{
			roomSliderSection.style.maxWidth="33%";
			roomSliderSection.style.margin="auto";  
			}  
		}

		var config = {
			slidesPerView: slidesPerView_lg,
			spaceBetween: 10,
			allowTouchMove: true,
			watchSlidesVisibility: true,
			loop: true,
			containerModifierClass: 'slider-container--',
			wrapperClass: 'slider-wrapper',
			slideClass: 'slider-slide',
			slideActiveClass: 'slider-slide--active',
			slideNextClass: 'slider-slide--next',
			slidePrevClass: 'slider-slide--prev',
			pagination: {
				el: '.rooms-slider .slider-pagination--relative',
				bulletClass: 'slider-pagination-bullet--dark',
				bulletActiveClass: 'slider-pagination-bullet--active',
				currentClass: 'slider-pagination-bullet--current',
				hiddenClass: 'slider-pagination-bullet--hidden',
				clickable: true,
			},
			lazy: {
				elementClass: 'lazy',
				loadPrevNext: true,
				loadedClass: 'lazy-loaded',
			},
			navigation: {
				prevEl: '.slider-icons.slider-icons--prev',
				nextEl: '.slider-icons.slider-icons--next',
			},
			breakpoints: {
				768: {
					slidesPerView: slidesPerView_sm,
					spaceBetween: 10,
				},
				1280: {
					slidesPerView: slidesPerView_md,
					spaceBetween: 20,
					allowTouchMove: false,
				},
			},
		};

		arrayOfSliders.push(new Swiper(slider, config));
	});
}
